import * as actionTypes from '../actionTypes/offerCampaign';


export function sendCampaignUserData(data) {
    return { type: actionTypes.SAVE_CAMPAIGN_USER_DATA_LOAD, data };
}
export function resetCampaignUserData() {
    return { type: actionTypes.RESET_CAMPAIGN_USER_DATA };
}
export function checkUserExists(phone) {
    return { type: actionTypes.CHECK_USER_EXISTS_LOAD, phone };
}
export function changeUserExistsValue(value) {
    return { type: actionTypes.CHANGE_USER_EXISTS_VALUE, value };
}
export function firstDealUserExists(phone) {
    return { type: actionTypes.FIRST_DEAL_USER_EXISTS_LOAD, phone };
}
